import React from "react";
import { LoadingScreen } from "./LoadingScreen";
import { ErrorDoodle } from "./components/ErrorDoodle";
import { useThoughtSpotStatusStore, ThoughtSpotStatus } from "./thoughtspot/status";
import { useInitializeThoughtspot } from "./thoughtspot/useInitializeThoughtspot";

export function ThoughtspotInitializer(props: React.PropsWithChildren) {
  useInitializeThoughtspot();

  return <>{props.children}</>;
}

export function ThoughtspotProtected({
  children,
  feature,
}: React.PropsWithChildren<{ feature: string }>) {
  const status = useThoughtSpotStatusStore((state) => state.status);

  if (status === ThoughtSpotStatus.Pending) {
    return <LoadingScreen />;
  }

  if (status === ThoughtSpotStatus.Failed) {
    return <ThoughtspotUnavailable feature={feature} />;
  }

  return <>{children}</>;
}

function ThoughtspotUnavailable({ feature }: { feature: string }) {
  return (
    <div className="flex w-full flex-1 flex-col items-center justify-center h-full min-h-[24rem] bg-backgroundGray px-4">
      <ErrorDoodle />
      <div className="mt-6 font-medium text-[32px] text-center">
        {feature} unavailable right now
      </div>
      <p className="mt-4 max-w-2xl text-feintGray font-medium text-center">
        Please try again later. If the problem persists, contact support.
      </p>
    </div>
  );
}
